export default __webpack_public_path__ + "static/media/bluePeople.0bcd4f23.svg";